import React from 'react';
import styled from 'styled-components';
import ColorConstants from '../../../constants/ColorConstants';
import CheckboxCheckIcon from '../../icons/svgs/CheckboxCheckIcon';
import { CHECKBOX_TEST_ID } from './checkbox.constants';

const defaultProps = {
    checked: false,
    checkedColor: ColorConstants.shamrock,
    className: '',
    disabled: false,
    label: '',
    onClick: () => {},
    unCheckedColor: ColorConstants.melrose,
};

const Checkbox = ({
    checked,
    checkedColor,
    className,
    disabled,
    label,
    onClick,
    unCheckedColor,
}) => {
    const handleOnClick = () => {
        if (!disabled && onClick) onClick();
    };

    return (
        <CheckboxWrapper
            isVisible={checked}
            onClick={handleOnClick}
            className={className}
            data-testid={CHECKBOX_TEST_ID.CHECK_BOX_WRAPPER}
        >
            <CheckboxCheckIcon />
            <CheckboxInput
                checked={checked}
                checkedColor={checkedColor}
                data-testid={CHECKBOX_TEST_ID.CHECK_BOX_INPUT}
                disabled={disabled}
                isChecked={checked}
                onChange={onClick}
                position="before"
                type="checkbox"
                unCheckedColor={unCheckedColor}
                title={label}
            />
            <CheckboxLabel />
        </CheckboxWrapper>
    );
};

Checkbox.defaultProps = defaultProps;

const CheckboxLabel = styled.label`
    color: #414141;
    font-weight: 400;
    height: 18px;
    width: 18px;
`;

const CheckboxInput = styled.input`
    display: none;
    & + ${CheckboxLabel}:${({ position }) => position} {
        background: ${({ isChecked, checkedColor, unCheckedColor }) => (isChecked ? checkedColor : unCheckedColor)};
        border: ${({ isChecked }) => (isChecked ? '1px solid transparent' : `1px solid ${ColorConstants['regal-blue-50%']}`)};
        border-radius: 6px;
        content: "\\00a0";
        cursor: pointer;
        display: inline-block;
        font-size: 10px;
        height: 18px;
        margin: 0;
        padding: 0;
        vertical-align: top;
        width: 18px;
        transition: background 0.25s ease;
    };
    &:checked + ${CheckboxLabel}:${({ position }) => position} {
        background: ${({ isChecked, checkedColor, unCheckedColor }) => (isChecked ? checkedColor : unCheckedColor)};
        color: #FFF;
        text-align: center;
        transition: background 0.25s ease;
    };
    &:checked + ${CheckboxLabel}:${({ position }) => position} {
        border-radius: 6px;
        font-weight: bold;
    };
`;

const CheckboxWrapper = styled.div`
    height: 18px;
    position: relative;
    width: 18px;
    
    &:hover {
        cursor: pointer;
    }
    
    svg {
        height: 8px;
        position: absolute;
        right: 4.7px;
        top: 6px;
        visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
        width: 8px;
    }
`;

export default Checkbox;
